// extracted by mini-css-extract-plugin
export default {"container":"FatalErrorMessage_container__PRXCC"};